module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "all-categories mt-0 mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("rewards")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_vm._l((_vm.rewards), function(reward, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-3"
    }, [_c('transition-group', {
      attrs: {
        "name": "fade-slow",
        "mode": "out-in",
        "appear": ""
      }
    }, [_c('reward-tile', {
      key: reward.id,
      attrs: {
        "reward": reward,
        "rewards": _vm.rewards,
        "currency": _vm.project.currency,
        "buttonColor": _vm.crowdOrRais(),
        "showButtons": !_vm.project.submitted
      }
    })], 1)], 1)
  }), _vm._v(" "), (_vm.showRewardForm) ? _c('reward-form', {
    attrs: {
      "close": _vm.closeRewardForm,
      "rewards": _vm.rewards,
      "currency": _vm.project.currency,
      "action": 'create',
      "buttonColor": _vm.crowdOrRais()
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.project.isSubmitted) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    class: 'btn btn-tile ' + _vm.crowdOrRais(),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showRewardForm = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("reward.new")))])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b36e581"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Form/Rewards.vue
// module id = 812
// module chunks = 1